<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="1000px"
    :title="$l('form_label_data_duplication') || '结算单分摊明细重复'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
    v-el-dialog-drag
  >
    <el-alert type="warning" show-icon :closable="false">
      <span slot="title">
        {{
          $l('form_label_share_already_exist') || '该结算单以下分摊明细已存在'
        }}
      </span>
      <div slot="default">
        <span class="mr-4"
          ><b class="color">{{ $l('INDEX.btn_cancel') || '取消' }}：</b
          >{{ $l('btn_cancel_application') || '取消申请' }}</span
        >
        <span
          ><b class="color">{{ $l('INDEX.btn_confirm') || '确认' }}：</b
          >{{ $l('btn_confirm_application') || '继续申请' }}</span
        >
      </div>
    </el-alert>

    <ShareTable
      ref="shareTable"
      :title="
        $l('form_label_already_exist_statement_share') || '已存在外运单分摊明细'
      "
      :disabled="true"
      :tableData="data"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import ShareTable from '../share-table'
export default {
  components: { ShareTable },
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.color {
  color: #409eff;
}
</style>
